/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { NavList, NavListItem, NavListFlyout, NavListFlyoutLink } from 'components/nav-list';
import { connect } from 'react-redux';
import { getProductsUrl, showLinks } from 'constants/common';

const MarketingNav = ({ location, emailAddress, quoteVersion }) => {
  const getQuotePageLink = `/get-quote-${quoteVersion}/`;
  const { rentersInsuranceUrl, idTheftProtectionUrl, petInsuranceUrl } = getProductsUrl();
  const showLink = showLinks();

  return (
    <NavList location={location}>
      <NavListItem
        location={location}
        to={rentersInsuranceUrl}
        showLink={showLink}
        renderFlyout={(props) => (
          <NavListFlyout {...props}>
            <NavListFlyoutLink to={rentersInsuranceUrl}>Renters Insurance</NavListFlyoutLink>
            <NavListFlyoutLink to={idTheftProtectionUrl}>Identity Theft Protection</NavListFlyoutLink>
            <NavListFlyoutLink to={petInsuranceUrl}>Pet Insurance</NavListFlyoutLink>
          </NavListFlyout>
        )}
      >
        Products
      </NavListItem>
      <NavListItem to={getQuotePageLink} showLink={showLink}>
        Get a Quote
      </NavListItem>
      <NavListItem to='/enroll/customer-info/' showLink={!!emailAddress && showLink}>
        Enroll
      </NavListItem>
    </NavList>
  );
};

MarketingNav.propTypes = {
  location: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.any]),
  emailAddress: PropTypes.string.isRequired,
  quoteVersion: PropTypes.string.isRequired,
};

MarketingNav.defaultProps = {
  location: null,
  emailAddress: null,
  quoteVersion: null,
};

export default connect(({ savedQuote: { emailAddress } }) => ({
  emailAddress,
}))(MarketingNav);
